import { clientApi } from 'shared/api/clientApi.ts'
import { refreshOrdersCount } from 'shared/api/orders-count-query'
import {
  MyOrderListResponse,
  UmrahMyOrder,
  UmrahMyOrderDetail,
  UmrahMyOrderParams,
  UmrahPaymentConfirmData,
} from 'shared/api/umrah/buy-tour/model.ts'
import { Response } from 'shared/models/general.ts'

export const UmrahBuyTourApi = {
  getMyOrdersList(params: UmrahMyOrderParams) {
    return clientApi.get<MyOrderListResponse>(`umra-tours/my-orders`, {
      params: params,
    })
  },

  getMyOrderDetail(orderId: string) {
    return clientApi.get<Response<UmrahMyOrderDetail>>(
      `umra-tours/my-orders/${orderId}`,
    )
  },

  async onConfirmPayment(data: UmrahPaymentConfirmData) {
    const response = await clientApi.post<Response<UmrahMyOrderDetail>>(
      `umra-tours/book`,
      data,
    )
    void refreshOrdersCount()
    return response
  },

  getLastMyOrder() {
    return clientApi.get<Response<UmrahMyOrder>>(`umra-tours/my-orders/last`)
  },
}
